/**
 * Can we hover on that platform
 */
export const isHoverEnabled = ():boolean => !(matchMedia('(hover: none)').matches)
